<!-- 排行榜 -->
<template>
  <a-card>
    <a-form
      @keyup.enter.native="$refs.table.commitProxy('reload')"
      class="myForm"
    >
      <a-row :gutter="24">
        <!-- <a-col :xl="8" :lg="8" :md="8" :sm="24">
          <a-form-item label="创建时间">
            <a-date-picker
              placeholder="开始时间"
              :locale="locale"
              v-model="queryParam.startTime"
              valueFormat="YYYY-MM-DD"
              class="query-group-cust"
            ></a-date-picker>
            <span class="query-group-split-cust"></span>
            <a-date-picker
              placeholder="结束时间"
              :locale="locale"
              v-model="queryParam.endTime"
              valueFormat="YYYY-MM-DD"
              class="query-group-cust"
            ></a-date-picker>
          </a-form-item>
        </a-col> -->
        <!-- <a-col :xl="4" :lg="5" :md="6" :sm="24">
          <a-form-item label="项目名称">
            <a-input
              placeholder="请输入"
              v-model="queryParam.project_name"
            ></a-input>
          </a-form-item>
        </a-col> -->
        <a-col :xl="4" :lg="5" :md="6" :sm="24">
          <a-form-item label="志愿者姓名">
            <a-input
              placeholder="请输入"
              v-model="queryParam.person_name"
            ></a-input>
          </a-form-item>
        </a-col>

        <a-col :xl="4" :lg="4" :md="4" :sm="24">
          <a-form-item>
            <a-button
              type="primary"
              @click="$refs.table.commitProxy('reload')"
              icon="search"
              >查询</a-button
            >
            <a-button
              type="primary"
              @click="searchReset"
              icon="reload"
              style="margin-left: 8px"
              >重置</a-button
            >
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 12px">
      <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
      <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
      >项
      <a style="margin-left: 24px" @click="onClearSelected">清空</a>
    </div> -->

    <vxe-grid
      ref="table"
      border
      size="small"
      resizable
      row-id="id"
      show-overflow
      highlight-hover-row
      @checkbox-change="selectChangeEvent"
      @checkbox-all="selectAllEvent"
      :seq-config="{
        startIndex: (tablePage.currentPage - 1) * tablePage.pageSize,
      }"
      :pager-config="tablePage"
      :sort-config="{ trigger: 'cell' }"
      :proxy-config="tableProxy"
      :columns="columns"
      :toolbar-config="tableToolbar"
    >
    </vxe-grid>
  </a-card>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";

export default {
  data() {
    let that = this
    return {
      locale,
      queryParam: {},
      selectedRowKeys: [],
      selectionRows: [],
      url: {
        list: "",
      },
      columns: [
        {
          type: "seq",
          width: "50",
          title: "排名",
          slots: {
            default: ({ seq }) => {
              return seq;
            },
          },
        },
        // {
        //   title: "操作",
        //   field: "action",
        //   slots: {
        //     default: "action",
        //   },
        // },

        {
          title: "志愿者姓名",
          field: "person_name",
        },
        // {
        //   title: "参与项目",
        //   field: "project_name",
        // },
        // {
        //   title: "打卡次数",
        //   field: "clock_time",
        // },
        {
          title: "积分",
          field: "integral",
        },
        {
          title: "性别",
          field: "sex",
        },
        {
          title: "年龄",
          field: "age",
        },
        {
          title: "电话",
          field: "phone",
        },
        {
          title: "地址",
          field: "address",
        },
      ],
      tablePage: {
        pageSize: 10,
        align: "right",
      },
      tableToolbar: {
        id: "tools",
        refresh: true, // 刷新按钮
        zoom: true, // 最大化按钮
        // 列宽操作记录
        resizable: { storage: true },
        // 列操作记录
        custom: { storage: true },
      },
      tableProxy: {
        sort: true, // 启用排序代理
        // 配置响应的数据属性
        props: {
          result: "result.records",
          total: "result.total",
        },
        ajax: {
          query: ({ page, sort, filters, form }) => {
            // console.log(this.queryParam);
            // return _this.$Request(this.$Interface.warn_info);
             return that.$getAction('');
            let data = {
              result: {
                current: 1,
                records: [
                  {
                    person_name: "Carson",
                    project_name: "测试项目一",
                    integral: 20,
                    clock_time: 2,
                    sex: "男",
                    age: "25",
                    phone: 13392211555,
                    address: "广东省广州市白云区启德路1号",
                  },
                ],
                size: 10,
                total: 1,
              },
            };

            return data;
          },
        },
      },
    };
  },

  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
      this.$refs.table.clearCheckboxRow();
    },

    selectChangeEvent({ checked, records }) {
      this.selectionRows = records;
      this.selectedRowKeys = records.map((it) => it.id);
    },
    selectAllEvent({ checked, records }) {
      this.selectionRows = records;
      this.selectedRowKeys = records.map((it) => it.id);
    },
    searchReset() {
      this.queryParam = {};
      this.loadData();
    },
    loadData() {
      this.$refs.table.commitProxy("query");
    },
    insertEvent() {
      this.subModal = true;
      this.selectRow = false;
    },
    deleteEvent() {
      let that = this;
      if (!this.selectionRows.length) {
        this.$message.error("至少选择一项");
        return;
      }
      that.removeEvent(that.selectedRowKeys.join(","));
    },
    removeEvent(ids) {},
    submitEvent() {},
    editEvent(row) {
      this.subModal = true;
      this.selectRow = true;
      this.formData = JSON.parse(JSON.stringify(row));
    },
    handleRemove1(file) {
      const index = this.fileListMain.indexOf(file);
      const newfileListMain = this.fileListMain.slice();
      newfileListMain.splice(index, 1);
      this.fileListMain = newfileListMain;
    },
    beforeUpload1(file) {
      let that = this;
      let param = new FormData();
      param.append("images", file);
      param.append("name", "images");
      param.append("filename", file.name);
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      that.fileListMain = [file];
      // axios.post(this.$Interface.prod_upload, param, config).then((res) => {
      //   if (res.data.code == 200) {
      //     let d = res.data.data;
      //     let img_id = d.id;
      //     let img = d.url;
      //     let url_thumb = d.url_thumb;
      //     file.img_id = img_id;
      //     file.url = img;
      //     file.url_thumb = url_thumb;
      //     that.fileListMain = [file];
      //     console.log(that.fileListMain);
      //   }
      // });
      return false;
    },
  },
};
</script>

<style scoped>
</style>
